module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2028-341cc3d518bd631c297a88ffa3881560.svg";